/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:   Mission Definition component step 1 of the mission creation process
Author: Deimos Space UK

Version: 1.0
*/

import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Container, Button } from 'react-bootstrap';
import Select from 'react-select';
import classNames from 'classnames';
import db from '../../../../utils/db/db'
import { useLocation } from 'react-router-dom';
import { getPetition } from '../../../../api/api';
import { toast } from 'react-toastify';

function MissionDefinition(props) {
    const [architectureType, setArchitectureType] = useState('')
    const [missions, setMissions] = useState('')
    const [version, setVersion] = useState('')
    const [nOrbits, setNOrbits] = useState()
    const [constellationName, setConstellationName] = useState('')
    const [associatedTo, setAssociatedTo] = useState([{ weighted_value: '', spacecraft_id: '' }])
    const [satellitesPerOrbit, setSatellitesPerOrbit] = useState([{ id: 0, satellites: 0, launch_year: 0, lifetime: 0 }])
    const [change, setChange] = useState(false)
    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const location = useLocation();


    useEffect(() => {
        if (architectureType.value === 'constellation' && nOrbits > 0) {
            const NewsatellitesPerOrbit = []
            for (let i = 0; i < nOrbits; i++) {
                if (satellitesPerOrbit[i]) {
                    NewsatellitesPerOrbit.push({ id: i, satellites: satellitesPerOrbit[i].satellites, launch_year: satellitesPerOrbit[i].launch_year, lifetime: satellitesPerOrbit[i].lifetime })
                }
                else {
                    NewsatellitesPerOrbit.push({ id: i, satellites: 0, launch_year: 0, lifetime: 0 })
                }

            }
            setSatellitesPerOrbit(NewsatellitesPerOrbit)
        }
    }, [architectureType, nOrbits, satellitesPerOrbit])

    useEffect(() => {
        if (props.id) {
            if (location.pathname.includes('clone')) {
                setDisabled(false)
            } else {
                setDisabled(true)
            }
        }

    }, [props.id, location.pathname])

    useEffect(() => {
        const data = sessionStorage.getItem('firstStep');
        if (data) {
            setLoading(false)
            const step1 = JSON.parse(data);
            setArchitectureType({ value: step1.architectureType, label: step1.architectureType })
            setMissions(step1.missions)
            setVersion(step1.version)
            setNOrbits(step1.nOrbits)
            setConstellationName(step1.constellationName)
            setAssociatedTo(step1.associatedTo)
            setSatellitesPerOrbit(step1.satellitesPerOrbit)
            setLoading(true)
        }

    }, [props.loading])




    const changeArchitectureType = (value) => {
        setNOrbits(0)
        setAssociatedTo([{ weighted_value: '', spacecraft_id: '' }])
        setSatellitesPerOrbit(0)
        setArchitectureType(value)
        props.checkArchitecture(value)
        db.files.clear();
        //delete second step from session storage
        sessionStorage.removeItem('secondStep')
        sessionStorage.removeItem('thirdStep')
        sessionStorage.removeItem('fourthStep')
    }
    const changeMissions = (value) => {
        setMissions(value)
    }
    const changeVersion = (value) => {
        setVersion(value)
    }


    const changeNOrbits = (value) => {
        setNOrbits(value)
    }
    const changeIndexShare = (value, index) => {
        const associatedToCopy = associatedTo
        associatedToCopy[index].weighted_value = value
        setAssociatedTo(associatedToCopy)
        setChange(!change)
    }
    const changeAssociatedTo = (value, index) => {
        const associatedToCopy = associatedTo
        associatedToCopy[index].spacecraft_id = value
        setChange(!change)

    }
    const addAssociatedTo = () => {
        const associatedToCopy = associatedTo
        associatedToCopy.push({ weighted_value: '', spacecraft_id: '' })
        setAssociatedTo(associatedToCopy)
        setChange(!change)

    }

    const changeSatellitesPerOrbit = (value, id) => {
        const satellitesPerOrbitCopy = satellitesPerOrbit
        satellitesPerOrbitCopy[id].satellites = parseInt(value)
        setSatellitesPerOrbit(satellitesPerOrbitCopy)
        setChange(!change)
    }

    const changeLaunchYearPerOrbit = (value, id) => {
        const satellitesPerOrbitCopy = satellitesPerOrbit
        satellitesPerOrbitCopy[id].launch_year = parseInt(value)
        setSatellitesPerOrbit(satellitesPerOrbitCopy)
        setChange(!change)
    }

    const changeLifeTimePerOrbit = (value, id) => {
        const satellitesPerOrbitCopy = satellitesPerOrbit
        satellitesPerOrbitCopy[id].lifetime = parseInt(value)
        setSatellitesPerOrbit(satellitesPerOrbitCopy)

        setChange(!change)

    }
    const setStepOne = async () => {
        const firstStep = {
            architectureType: architectureType.value,
            missions: missions,
            version: version,
            nOrbits: nOrbits,
            constellationName: constellationName,
            associatedTo: associatedTo,
            satellitesPerOrbit: satellitesPerOrbit,
        }
        if(!disabled){
        getPetition(`/api/mission/exists?name=${missions}&version=${version}`)
            .then((data) => {
                if (data.exists) {
                    toast.warning('This combination of mission name and version already exists in the database. Please change either the mission’s name or version before continuing to the next debrisindex calculation steps')
                }
                else {
                    sessionStorage.setItem('firstStep', JSON.stringify(firstStep))
                    props.handleNext()
                }
            })
        }
        else{
            sessionStorage.setItem('firstStep', JSON.stringify(firstStep))
            props.handleNext()
        }
    }

    const getSatilletesInOrbit = (id) => {
        const satellites = satellitesPerOrbit.find(satellite => satellite.id === id)
        return satellites.satellites
    }
    const getLaunchYearInOrbit = (id) => {
        const satellites = satellitesPerOrbit.find(satellite => satellite.id === id)
        return satellites.launch_year
    }

    const getLifeTimeInOrbit = (id) => {
        const satellites = satellitesPerOrbit.find(satellite => satellite.id === id)
        return satellites.lifetime
    }

    const removeAssociatedTo = (index) => {
        const associatedToCopy = associatedTo
        associatedToCopy.splice(index, 1)
        setAssociatedTo(associatedToCopy)
        setChange(!change)
    }
    const validateForm = () => {

        let valid = true

        if (props.id && !location.pathname.includes('clone')) {
            return false
        }


        if (missions.length <= 0) {
            valid = false
        }
        if (version.length <= 0) {
            valid = false
        }
        if (architectureType === '') {
            valid = false
        }
        if (architectureType.value === 'single' && missions.length === 0) {
            valid = false
        }
        if (architectureType.value === 'constellation') {
            return missions.length <= 0 || nOrbits <= 0 || constellationName?.length <= 0
        }
        if (architectureType.value === 'carrier' || architectureType.value === 'launcher') {
            associatedTo.forEach(associated => {
                if (associated.weighted_value.length <= 0 || associated.spacecraft_id.length <= 0) {
                    valid = false
                }
            })
        }
        return !valid
    }

    const capitalize = (s) => {

        if (s.label) {
            return { value: s.value, label: s.label.charAt(0).toUpperCase() + s.label.slice(1) }
        }
        return s
    }

    return (
        <Container style={{ justifyContent: 'center', alignItems: 'center', overflowY: 'auto', width: '100%', height: '100%', paddingBottom: '100px', }}>
            <Row>
                <Col xs={12}>
                    <Form noValidate>
                        <Row>
                            <Col xs={12} sm={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={{ color: '#003247' }}>Mission name</Form.Label>
                                    <Form.Control
                                        disabled={disabled}
                                        value={missions}
                                        onChange={e => changeMissions(e.target.value)}
                                        required
                                        isInvalid={missions.length > 30 || missions.includes(' ')}
                                        type="text"
                                        placeholder="Mission name" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label style={{ color: '#003247' }}>Version</Form.Label>
                                    <Form.Control
                                        isInvalid={version.length > 20 || version.includes(' ')}
                                        disabled={disabled} value={version} onChange={e => changeVersion(e.target.value)} required type="text" placeholder="Version" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4}>

                                <Row>
                                    <Col xs={12} >
                                        <Form.Label style={{ color: '#003247' }}>Mission architecture</Form.Label>
                                    </Col>
                                    <Col xs={12}>
                                        <Select
                                            isDisabled={disabled}
                                            onChange={(value) => changeArchitectureType(value)}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            value={capitalize(architectureType)}
                                            options={[
                                                { value: 'single', label: 'Single' },
                                                { value: 'constellation', label: 'Constellation' },
                                                { value: 'launcher', label: 'Launcher servicer' },
                                                { value: 'carrier', label: 'Carrier servicer' },

                                            ]}></Select>
                                    </Col>
                                </Row>

                            </Col>

                        </Row>
                        {(architectureType.value === 'carrier' || architectureType.value === 'launcher') && (

                            <Row style={{ paddingTop: '15px' }}>

                                <Col xs={12} >
                                    <Form.Group className="mb-3">
                                        {associatedTo && associatedTo.length > 0 && (
                                            associatedTo.map((item, index) => (
                                                <Row>
                                                    <Col xs={5} >
                                                        <Form.Group className="mb-3">
                                                            <Form.Label style={{ color: '#003247' }}>Index share</Form.Label>
                                                            <Form.Control
                                                                value={item.weighted_value}
                                                                onChange={e => changeIndexShare(e.target.value, index)}
                                                                required
                                                                disabled={disabled}
                                                                isInvalid={item.weighted_value > 100 || item.weighted_value < 0}
                                                                type="number" />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={8} md={6}>
                                                        <Form.Label style={{ color: '#003247' }}>Associated to</Form.Label>
                                                        <Form.Control
                                                            style={{ marginBottom: '10px' }}
                                                            value={item.spacecraft_id}
                                                            disabled={disabled}
                                                            onChange={e => changeAssociatedTo(e.target.value, index)}
                                                            isInvalid={item.spacecraft_id <= 0}
                                                            required
                                                        />
                                                    </Col>
                                                    <Col xs={1} >

                                                        <Button disabled={disabled} style={{ marginTop: '1.8rem' }} onClick={() => removeAssociatedTo(index)} key={item.id} variant={'light'} className="btn-icon">
                                                            <i className={classNames('mdi', 'mdi-delete',)}></i>
                                                        </Button>

                                                    </Col>
                                                </Row>
                                            ))
                                        )}
                                        <Row>
                                            <Col xs={12}    >
                                                <Button disabled={disabled} onClick={() => addAssociatedTo()} variant={'secondary'} className="btn-icon " style={{ background: '#003247', borderColor: '#003247', display: 'flex', justifySelf: 'flex-end' }}>
                                                    <i className={classNames('mdi', 'mdi-pen-plus',)}></i>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}
                        {(architectureType.value === 'constellation') && (
                            <Row style={{ paddingTop: '5px' }}>
                                <Col xs={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={{ color: '#003247' }}>Number of planes</Form.Label>
                                        <Form.Control min={0} value={nOrbits} onChange={e => changeNOrbits(e.target.value)} required type="number" placeholder="Number of orbits: integer" />
                                    </Form.Group>
                                </Col>
                                <Col xs={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label style={{ color: '#003247' }}>Constellation name</Form.Label>
                                        <Form.Control value={constellationName} onChange={e => setConstellationName(e.target.value)} required type="string" />
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}
                        {(architectureType.value === 'constellation' && nOrbits > 0 && satellitesPerOrbit.length > 0) && (
                            <Row style={{ paddingTop: '15px' }}>
                                <Col xs={12}>
                                    <h4 style={{ color: '#003247' }}>Spacecrafts</h4>
                                </Col>
                                {satellitesPerOrbit.map((orbit, index) => (
                                    <>
                                        <Col xs={12}>
                                            <h5 style={{ color: '#003247' }}>Plane {index + 1}</h5>
                                        </Col>
                                        <Col xs={3} key={orbit.id + 'constellationOrbit'}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={{ color: '#003247' }}>Satellites per orbit</Form.Label>
                                                <Form.Control value={getSatilletesInOrbit(orbit.id)} min={0} onChange={e => changeSatellitesPerOrbit(e.target.value, orbit.id)} required type="number" placeholder="Number of satellites" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={3} key={orbit.id + 'constellationYear'}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={{ color: '#003247' }}>Years for deployment</Form.Label>
                                                <Form.Control value={getLaunchYearInOrbit(orbit.id)} min={0} onChange={e => changeLaunchYearPerOrbit(e.target.value, orbit.id)} required type="number" placeholder="Launch year" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={3} key={orbit.id + 'constellationLifetime'}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={{ color: '#003247' }}>Lifetime [years]</Form.Label>
                                                <Form.Control value={getLifeTimeInOrbit(orbit.id)} min={0} onChange={e => changeLifeTimePerOrbit(e.target.value, orbit.id)} required type="number" placeholder="Lifetime" />
                                            </Form.Group>
                                        </Col>
                                    </>
                                ))}

                            </Row>
                        )}
                    </Form>

                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                        <Button disabled={validateForm()} style={{ background: '#003247', borderColor: '#003247' }} onClick={setStepOne}>
                            Next
                        </Button>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default MissionDefinition